import React from 'react';
import { Select, Form } from 'antd';
// const Option = Select.Option;
const VehicleDocument = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Документ ТС">
      {getFieldDecorator('vehicleDocument')(
        <Select
          placeholder="Выберите документ ТС"
          disabled
          getPopupContainer={trigger => trigger.parentNode}
        />
      )}
    </Form.Item>
  );
};

export default VehicleDocument;
